import { black, darkGray, textGray } from 'modules//colors';
import { spacing } from 'modules/metrics';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.xl}px;
  max-width: 1440px;
  margin: 0 auto;
  justify-content: center;
  color: ${textGray};
  border-radius: 12px;
  line-height: 22px;

  ol {
    list-style: decimal;
    padding-left: 32px;
  }

  ul {
    list-style-type: disc;
    padding-bottom: ${spacing.lg}px;
    padding-inline-start: 32px;
  }

  li {
    padding: ${spacing.md}px 0;
  }

  strong {
    font-weight: 500;
    color: ${darkGray};
  }

  p {
    padding: ${spacing.md}px 0;
  }
`;

export const Title = styled.h1`
  align-self: center;
  font-weight: 500;
  color: ${black};
  font-size: 34px;
  padding: 160px 0;
  line-height: 36px;
`;

export const Heading = styled.h2`
  font-weight: 500;
  color: ${black};
  padding: ${spacing.xl}px 0 ${spacing.md}px 0;
`;

export const SubHeading = styled.h3`
  color: ${black};
  padding: ${spacing.lg}px 0;
`;
